<template>
  <b-container fluid id="form-container" ref="formContainer">
    <b-row>
      <b-col>
        <h2>Hiring Stage Goal Settings</h2>
        <p>These are application settings related to setting up the goal for requests to stay in a specific hiring stage. Values should be entered in units of days</p>
      </b-col>
    </b-row>

    <b-row>
      <b-col>
        <form-summary :validator="$v" ref="errorContainer" id="errorContainer"/>
      </b-col>
    </b-row>

    <b-row>
      <b-col>
        <p class="h5 font-weight-bold mt-4">Hiring Stage Goals</p>
        <hr class="mt-0"/>
      </b-col>
    </b-row>

    <b-row>
        <b-col>
            <BaseTextInput v-model="setting.hiring_stage_goal_audit" 
                            :v="$v.setting.hiring_stage_goal_audit"
                            label="Audit Goal"
                            tip=""
                            slug="sr1"/>
        </b-col>
    </b-row>

    <b-row>
        <b-col>
            <BaseTextInput v-model="setting.hiring_stage_goal_draft" 
                            :v="$v.setting.hiring_stage_goal_draft"
                            label="Draft Posting Goal"
                            tip=""
                            slug="sr2"/>
        </b-col>
    </b-row>

    <b-row>
        <b-col>
            <BaseTextInput v-model="setting.hiring_stage_goal_screen" 
                            :v="$v.setting.hiring_stage_goal_screen"                            
                            label="Screening Goal"
                            tip=""
                            slug="sr3"/>
        </b-col>
    </b-row>

    <b-row>
      <b-col>
        <BaseTextInput v-model="setting.hiring_stage_goal_interview"
                       :v="$v.setting.hiring_stage_goal_interview"
                       label="Roster Interview Goal"
                       tip=""
                       slug="sr3"/>
      </b-col>
    </b-row>

    <b-row>
      <b-col>
        <hr/>
         <b-button type="button" variant="primary" @click="saveSetting">Save</b-button>
      </b-col>
    </b-row>

  </b-container>
</template>

<script>
import axios from "axios"
import { required, email, minLength, maxLength, numeric, requiredUnless, requiredIf } from 'vuelidate/lib/validators'

export default {
  data: () => ({
    setting: { },
  }),
  created() {
    this.loadSetting()
  },
  validations() {
    return {
      setting: {
        hiring_stage_goal_audit: {
          required,
        },
        hiring_stage_goal_draft: {
          required,
        },
        hiring_stage_goal_screen: {
          required,
        },
        hiring_stage_goal_interview: {
          required,
        },
      }
    }
  },
  methods: {
    loadSetting() {
      axios.post(`${process.env.VUE_APP_API_BASE_URL}/admin/settings/query`, 
          ['hiring_stage_goal_audit', 'hiring_stage_goal_draft', 'hiring_stage_goal_screen', 'hiring_stage_goal_interview']
      ).then(response => { this.setting = response.data.settings })
    },
    saveSetting() {
      this.$v.$touch();
      if (this.$v.$invalid) {
          this.$nextTick(() => {
              document.getElementById('form-container').scrollIntoView()
          })
          return
      }

      axios.put(`${process.env.VUE_APP_API_BASE_URL}/admin/settings`, this.setting)
          .then(response => { 
            this.$bvToast.toast('Hiring Stage Goal Settings Updated', {
              title: 'Status',
              toaster: 'b-toaster-top-center',
              solid: true,
              variant: 'success',
              appendToast: true
            })
           })
    }
  }
}
</script>

<style>

</style>
